import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Loader from './../shared/loader'
import CryptoJS from 'crypto-js'
import Pagination from './../shared/pagination'
import multipickerassign from '../multipickerassign'
import { BasicSelect } from 'vue-search-select'
import Vue from 'vue';
// import '../pickerAssign copy/node_modules/vue-search-select/dist/VueSearchSelect.css'
export default {
	name: 'pickerassign',
	components: {
		//Paginate,
		Pagination,
		DatePicker,
		Loader,
		BasicSelect,
		multipickerassign,
	},
	data() {
		return {
			fromDateErr: '',
			toDateErr: '',
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// currentPage: 0,
			// getNewWarehouseData:'',
			listOrdersData: [],
			modalShow: false,
			modalMessageShow: false,
			displayMsg: false,
			successErrorMsg: "",
			orderid: "",
			fromDateFlt: "",
			toDateFltShip: "",
			fromDateFltShip: "",
			toDateFlt: "",
			newActionMsg: "",
			modelMessage: "",
			// totalPage: 0,
			// pageNo: 0,
			activeClass: 'btn-success',
			warningClass: 'btn-warning',
			clientdata: [],
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			listMerchantData: [],
			clientid: '',
			client: '',
			merchant: '',
			warehouseid: '',
			warehouse: '',
			ClientErr: '',
			WarehouseErr: '',
			MerchantErr: '',
			SelectPickerErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			pickerAssignmentShow: false,
			cancelOrderId: [],
			loginuserid: '',
			searchchannel: '',
			channellist: [],
			pickerid: '',
			isLoading: false,
			pickerListData: '',
			//pageLimit: 10,

			selectAll: false,
			orderids: [],
			orderclass: '',
			checkallflag: true,
			item: {
				value: '',
				text: ''
			},
			listMerchantData1: [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }],
			assignmultipicker: false,
			filterData: {},
			selectedRow: {},
			showlist: true,
			searchFlag1: false,
			length: '',
			only_btoborder: false,
			searchselfship: '',
			defaultVal:0,
			isLoading:false,
			zone:false,
			searchzone:'',
			listZoneData:[],
			searchSLA :'',
			slaclient:[],
			slaflag:false
				}
	},
	filters: {
		moment: function (date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	watch:{
       toDateFltShip(newVal){
		 if(newVal){
			const selectedDate=new Date(newVal);
			if(selectedDate.getHours()===0 && selectedDate.getMinutes()===0){
				selectedDate.setHours(23,59);
				this.toDateFltShip=selectedDate
			}
		 }
	   }
	},
	mounted() {
		this.calldateFunction();
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);

		var roleids = userdetail.roleid.split(',');
		for (var i = 0; i < roleids.length; i++) {
			if (roleids[i] == 40) {
				this.purchasingManager = parseInt(userdetail.roleid);
				this.isTrue = true;
			}
		}
		this.loginuserid = userdetail.userid;
		this.pageNo = 0;
		var slaconfig = window.localStorage.getItem('slaconfig');
		this.slaclient = JSON.parse(slaconfig);

		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined' )
		{
		this.getMerchantList();
		this.getSalesChannels();
		this.getPickersList();
		}
		this.slaflag = this.slaclient.some(item => {
			if (item.clientid == this.clientid) {
			  return true;
			} else {
			  this.slaflag = false;
			  return false;
			}
		  });

		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.loginUserEmail = userdetail.email;
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();

				break;

			case 'client_user':
				this.loginUserEmail = userdetail.email;
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				this.getPickersList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	}, // End computed
	methods: {
		callParent() {
			this.showlist = true;
		},
		// assignmultipicker(){
		// 	this.selectedRow = data
		// 	this.showlist = 'Multipicker';
		// },
		reset() {
			this.item = {}
		},
		onSelect(item) {
			// select option from parent component
			this.item = item
			this.merchant = item.value;

		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		// dateFormatFRT(date) {
		// 	if (!date) return '';
		// 	return moment(date).format('DD-MM-YY HH:mm:ss');
		// },
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		shipDateFormat1(date){
            if (!date) return '';
			const time = moment(date).format('HH:mm:ss');
			return moment(date).format('YYYY-MM-DD') + " " + time;
		},
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.toDateFlt = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 7);
			this.fromDateFlt = dt;
		},
		selectAllCheckbox: function () {
			if (this.checkallflag == true) {
				//this.rackIds = [];
				if (this.selectAll) {
					for (let order in this.listOrdersData) {
						if (this.orderids.indexOf(this.listOrdersData[order].orderid) == -1)
							this.orderids.push(this.listOrdersData[order].orderid);
					}
				} else {
					for (let order in this.listOrdersData) {
						if (this.orderids.indexOf(this.listOrdersData[order].orderid) >= 0)
							this.orderids.splice(this.orderids.indexOf(this.listOrdersData[order].orderid), 1);
					}
				}
			} else {
				this.$alertify.error(this.$t('common.disabledError'));
			}

		},
		resetAll: function (myAction) {
			if (myAction == 1) {
				this.orderids = [];
				this.selectAll = false;
			} else { }
		},
		showZone(){
           if(this.orderclass == 'single'){
			 this.zone = true;
			 this.getRacksZonesList()

		   }else{
			this.zone = false;
		   }
		},
		async getRacksZonesList() {
			try {
				this.listZoneData = [];
				this.searchzone = '';
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '')
				if (this.warehouseid) {
					this.isLoading = true
					this.listZoneData = []
					this.isLoading = true
					var userToken = window.localStorage.getItem('userToken')
					var myStr = userToken.replace(/"/g, '')
					let result = await axios({
						method: 'POST',
						//'url': apiUrl.api_url + 'getZonesByWarehouse',
						'url': apiUrl.api_url + 'getZonesByClient',
						'data': {
							clientid: this.clientid,
							warehouseid: this.warehouseid	
						},
						'headers': {
							'Authorization': 'Bearer ' + myStr
						}
					})
					this.listZoneData = result.data.data.data;
					this.isLoading = false
				}
			} catch (err) {
				console.log(err);
			}

		},

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}
		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		splitshipment(isSplit,data){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true
			this.input = ({
					clientid: window.localStorage.getItem("selectedClient"),
					warehouseid: window.localStorage.getItem("selectedWarehouse"),
					orderid: data.orderid,
					issplit: isSplit,
					useremail: this.loginUserEmail,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'splitshipment/updateUniwareShipment',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
                if(result.data.ErrorCode == 0){
					this.listOrdersData = this.listOrdersData.map(item =>{
						if(item.orderid == data.orderid ){
							item.defaultVal = 1;
						}
						return item;
					})
					this.$alertify.success(result.data.msg);
					this.isLoading = false
					return true;
				}else{
					this.$alertify.error(result.data.msg);
					this.isLoading = false
					return false;
				}

				}, error => {
					console.error(error)
				})
		},
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: window.localStorage.getItem("selectedClient"),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						this.item = {
							value: '',
							text: ''
						},
							this.listMerchantData1 = [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }]
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname

							})
						})

					}
				}, error => {
					//	console.error(error)
				})
		},

		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});
		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		getPickersList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getWarehousePickerList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.pickerListData = result.data.data.data;
				}, error => {
					console.error(error)
				})
		},
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchant = '';
		// 		this.getMerchantList();

		// 		if (this.clientid)
		// 		{
		// 			this.getMerchantList();
		// 			this.getSalesChannels();
		// 		}


		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid) {
		// 				this.getPickersList();
		// 				// this.getMerchantList();
		// 				//this.getOrderList();
		// 			}
		// 		}
		// 		this.orderids = [];
		// 	}
		// 	this.totalRows = 0;
		// 	this.listOrdersData = [];
		// 	this.listMerchantData = [];
		// 	this.pageNo = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.listOrdersData = [];
		// 	this.pageNo = this.totalPage = 0;
		// 	this.totalRows = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getPickersList();
		// 			this.getRacksZonesList()
		// 		} else {
		// 			this.getClientList();
		// 			this.getRacksZonesList()
		// 		}
		// 	}
		// },
		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (this.clientid == '') {
				this.WarehouseErr = this.$t('srReport.clientError');
				return false;
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'orderSalesChannelList',
				'data': {
					clientid: this.clientid
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.channellist = result.data.data;
				}, error => {
					console.error(error);
				});
		},

		getOrderList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (this.fromdate != "") {
				this.fromdate = this.dateFormat(this.fromdate) + " 00:00:00";
			}
			if (this.todate != "") {
				this.todate = this.dateFormat(this.todate) + " 23:59:59";
			}

			// this.ClientErr = '';
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (this.fromDateFlt == null || this.fromDateFlt == '') {
				this.fromDateErr = this.$t('common.fromTypeError');
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (this.toDateFlt == null || this.toDateFlt == '') {
				this.toDateErr = this.$t('common.toDateError');
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (this.only_btoborder == false) {
				this.only_btoborder = 0
			} else {
				this.only_btoborder = 1

			}
			this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem("selectedClient"),
				orderid: this.orderid.trim(),
				fromddate: this.dateFormat1(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				fromddateship: this.shipDateFormat1(this.fromDateFltShip),
				todateship: this.shipDateFormat1(this.toDateFltShip),
				saleschannel: this.searchchannel,
				orderclass: this.orderclass,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				merchantid: this.merchant,
				only_btoborder: this.only_btoborder,
				searchselfship: this.searchselfship,
				zoneid:this.searchzone,
				slastatus : this.searchSLA
			});
			this.filterData = this.input

			console.log("tinput",this.input)

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'unallocatedOrderList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listOrdersData = result.data.data.data.data;

					this.listOrdersData = this.listOrdersData.map(item =>{
						if(!item.defaultVal){
							item.defaultVal = 0;
						}
						return item
					})

					if (result.data.data.ErrorCode == 1) {
						this.resultCount = 0;
					} else {
						this.totalRows = result.data.data.data.count;
						this.resultCount = result.data.data.data.count;
						this.checkallflag = result.data.data.data.checkallflag;

						if (this.resultCount > 0) {
							if (this.totalRows < this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.resultCount / this.pageLimit)
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},

		btoborder(ev) {
			let checkbox11 = document.getElementById("only_btoborder1")
			this.only_btoborder = checkbox11.checked
			if (checkbox11.checked == false) {
				this.only_btoborder = 0
			}
			else {
				this.only_btoborder = 1
			}
		},
		arrowOrderId(data) {
			// if (this.orderids.indexOf(data[order].orderid) >= 0)
			// this.orderids.splice(this.orderids.indexOf(data[order].orderid), 1);
			// console.log(this.orderids)

		},

		getmultipicker(data) {
			this.selectedRow = data
			this.showlist = 'Multipicker';
		},
		assignOrderToPicker() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.pickerAssignmentShow = false;
			if (localStorage.getItem("selectedClient") == '') {
				this.$alertify.error(this.$t('common.clientMsg'));
				return false;
			}
			if (this.pickerid == 0) {
				this.$alertify.error(this.$t('common.selectPickerErr'));
				return false;
			}
			if (this.orderids == 0) {
				this.$alertify.error(this.$t('common.selectAtLeastOneOrderErr'));
				return false;
			}
			this.isLoading = true;
			this.input = {
				clientid: window.localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				selectedorder: this.orderids,
				userid: this.loginuserid,
				pickerid: this.pickerid,
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'assignOrderToPicker',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.totalPage = this.totalPage - this.orderids.length
						this.$alert(result.data.data.msg, '', "success");
						// this.$alertify.success(result.data.data.msg);
						//this.getPaginationData(this.totalPage)
						this.getOrderSerach();
					} else {
						this.$alert(result.data.data.msg, '', "error");
						// this.$alertify.error(result.data.data.msg);
					}
					this.isLoading = false;
					this.selectAll = false;
					this.pickerid = '';
					this.orderids = [];

				}, error => {
					console.error(error);
				});
		},
		getbtobdata() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			// if (this.fromdate != "") {
			// 	this.fromdate = this.dateFormat(this.fromdate) + " 00:00:00";
			// }
			// if (this.todate != "") {
			// 	this.todate = this.dateFormat(this.todate) + " 23:59:59";
			// }

			// this.ClientErr = '';
			if (window.localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('srReport.clientError');
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (window.localStorage.getItem("selectedWarehouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: window.localStorage.getItem("selectedClient"),
				orderid: this.selectedRow.orderid,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
			});
			// this.filterData = this.input

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getbtoborderdata',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listOrdersData = result.data.data.data.data;

					if (result.data.data.ErrorCode == 1) {
						this.resultCount = 0;
					} else {
						this.filterData = result;
						this.totalRows = result.data.data.data.count;
						this.resultCount = result.data.data.data.count;
						this.checkallflag = result.data.data.data.checkallflag;

						if (this.resultCount > 0) {
							if (this.totalRows < this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.resultCount / this.pageLimit)
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},

		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.pageLimit
		// 	this.getOrderList()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getOrderList()
		},
		getOrderSerach() {
			this.totalPage = 0;
			this.currentPage = 1;
			this.resultCount = 0;
			this.searchFlag = true;
			this.searchFlag1 = true;
			this.getOrderList();
			//	this.getMerchantList(); //added
		},
		resetOrderSerach() {
			this.item = {
				value: '',
				text: ''
			};
			this.searchSLA=''
			// this.listMerchantData1 = [{ value: '', text: this.$t('common.merchantPlaceholder') }];
			this.totalRows = 0;
			this.orderid = '';
			this.merchant = '';
			this.fromDateFlt = "";
			this.MerchantErr = "";
			this.toDateFlt = "";
			this.fromDateFltShip = "";
			this.toDateFltShip = "";
			this.orderclass = '';
			this.searchchannel = '';
			this.listOrdersData = [];
			this.pageNo = 0;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = false;
			this.searchFlag1 = false;
			this.pickerid = '';
			this.orderids = [];
			this.fromDateErr = '';
			this.toDateErr = '';
			if (this.user_type == 'warehouse_user')
			{
				// this.client = '';
				// this.clientid = '';
			}
			else if (this.user_type == 'client_user')
				// this.warehouse = '';
			{

			}
			else {
				// this.client = '';
				// this.warehouse = '';
				// this.clientid = '';
			}
			this.only_btoborder = '';
			this.searchselfship = '';
			this.searchzone = '';
            this.zone = false;

		},

		onSubmit: function () {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	} // end methods
};



// WEBPACK FOOTER //
// ./src/views/components/pickerAssign/pickerAssign.component.js